export const PAYLOAD = { 'role': 'web_anon' }



// WEBPACK FOOTER //
// ./src/constants/payload.js